import _get from "lodash/get";
import { IMAGE_SIZES } from '../constants';
/**
 * Get name of current entity or ancestor entities.
 *
 * @private
 *
 * @todo This function should likely be avoided going forward. It is
 *     overly generic and doesn't accurately represent the name logic
 *     associated with each product type. Instead, we should clarify
 *     what specific name is used for specific selectors (offer vs
 *     product vs institution, .display_name vs. .name, etc).
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 *
 * @return {string} Name.
 */

export var getNameWithFallbacks = function getNameWithFallbacks(marketplaceEntity) {
  return _get(marketplaceEntity, 'name') || _get(marketplaceEntity, 'product.name') || _get(marketplaceEntity, 'product.institution.name');
};
/**
 * Get an entity's image URL by specific size, with fallbacks.
 *
 * @param {Object} marketplaceEntity The marketplace entity.
 * @param {string} size Canonical image size to select.
 *
 * @return {string} Image URL.
 */

export var getImageBySize = function getImageBySize(marketplaceEntity, size) {
  return size && _get(marketplaceEntity, "details.image_source_".concat(size, ".value")) || _get(marketplaceEntity, "details.image_source_".concat(IMAGE_SIZES.LARGE, ".value")) || _get(marketplaceEntity, "details.image_source_".concat(IMAGE_SIZES.MEDIUM, ".value")) || _get(marketplaceEntity, 'details.image_source.value');
};
/**
 * Get a WordPress augmented marketplaceEntity's additional data object.
 *
 * @param   {Object} marketplaceEntity  The `additional_data` augmented entity
 * @return  {Object}                    additional_data entity
 */

export var getAdditionalData = function getAdditionalData(marketplaceEntity) {
  return _get(marketplaceEntity, 'additional_data');
};